import Link from 'next/link';
import styled, { css } from 'styled-components';
import { palette } from 'styled-tools';

import { fontSize, FontSizes, fontWeight, FontWeights, minWidth, Text } from '@calm-web/design-system';
import { ChevronRightCenterd as _ChevronRightCenterd } from '@calm-web/icons';

// Shared between the internal (Next Link) and external (anchor) variants below — styled-components
// can't share one styled() call across two different underlying elements/components.
const bannerStyles = css`
	align-items: center;
	background-color: ${palette('darkBlue')};
	border-radius: 16px;
	display: flex;
	justify-content: space-between;
	margin-bottom: 24px;
	padding: 20px;
	text-decoration: none;
	width: 100%;

	${minWidth('tablet')} {
		padding: 24px 32px;
	}
`;

export const InternalWrapper = styled(Link)`
	${bannerStyles}
`;

export const ExternalWrapper = styled.a`
	${bannerStyles}
`;

export const IconAndCopyWrapper = styled.div`
	align-items: center;
	display: flex;
	min-width: 0;
`;

export const ImageWrapper = styled.div`
	border-radius: 8px;
	flex-shrink: 0;
	height: 48px;
	margin-right: 16px;
	overflow: hidden;
	position: relative;
	width: 48px;
`;

export const CopyWrapper = styled.div`
	display: flex;
	flex-direction: column;
	min-width: 0;
`;

export const ChevronRightCenterd = styled(_ChevronRightCenterd)`
	flex-shrink: 0;
	height: 20px;
	margin-left: 16px;
	transform: rotate(180deg);
	width: 20px;
	path {
		fill: ${palette('white')};
	}
`;

export const Title = styled(Text).attrs({
	el: 'h3',
	color: 'white',
	weight: FontWeights.Demi,
	// Heading margins from the design-system default would open a gap inside the banner.
	noMargin: true,
})`
	${fontWeight(FontWeights.Demi)}
	${fontSize(FontSizes.lg)}
`;

export const Subtitle = styled(Text).attrs({
	el: 'p',
	color: 'white',
	weight: FontWeights.Regular,
	noMargin: true,
})`
	${fontSize(FontSizes.sm)}
	opacity: 0.8;
`;
